import PropTypes from "prop-types";
import { useTheme } from "@mui/material/styles";
import { Avatar, Box, ButtonBase } from "@mui/material";
import LogoSection from "../LogoSection";
import ProfileSection from "./ProfileSection";
import { IconMenu2 } from "@tabler/icons";
import { color } from "../../../utils/color";
const Header = ({ handleLeftDrawerToggle }) => {
  const theme = useTheme();
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        width: "100%",
        py: 1,
      }}
    >
      {/* Logo & Drawer Toggle */}
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: { xs: 1.5, sm: 2.5 },
        }}
      >
        <Box component="span" sx={{ display: { xs: "none", md: "block" } }}>
          <LogoSection />
        </Box>
        <ButtonBase
          sx={{
            borderRadius: "12px",
            overflow: "hidden",
            border: `1px solid ${color.bg}`,
          }}
        >
          <Avatar
            variant="rounded"
            sx={{
              ...theme.typography.commonAvatar,
              ...theme.typography.mediumAvatar,
              transition: "all .2s ease-in-out",
              background: color.fg,
              color: color.bg,
              "&:hover": {
                background: color.bg,
                color: color.fg,
              },
            }}
            onClick={handleLeftDrawerToggle}
          >
            <IconMenu2 stroke={1.5} size="1.3rem" />
          </Avatar>
        </ButtonBase>
      </Box>
      <Box sx={{ flexGrow: 1 }} />
      {/* Profile Section */}
      <ProfileSection />
    </Box>
  );
};
Header.propTypes = {
  handleLeftDrawerToggle: PropTypes.func,
};
export default Header;